// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

export default class ScrollHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  didMount() {
    this.element.addEventListener('scroll',this.handleScroll);
  }

  handleScroll() {
    cookie.set(`scrollHandler`, this.element.scrollTop, {expires: ((1/24)/60), path: '/'});
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ScrollHandler.js